jQuery(function($){
    if ($('.faq-schema').length == 0){
        return;
    }

    $(".faq-schema__item").on("click", function () {
        const $item = $(this);
        const $answer = $item.find(".faq-schema__antwoord");
    
        if ($item.hasClass("active")) {
            $item.removeClass("active");
            $answer.animate({ height: 0 }, 300);
        } else {
          const fullHeight = $answer.prop("scrollHeight");
          $item.addClass("active");
          $answer.animate({ height: fullHeight }, 300);
        }
      });
});